import { hashStringToInt } from "@/utils/hashUtils";

const COLOR_PALETTE = [
  "#D32F2F",
  "#C62828",
  "#B71C1C",
  "#388E3C",
  "#2E7D32",
  "#1B5E20",
  "#1976D2",
  "#1565C0",
  "#0D47A1",
  "#512DA8",
  "#4527A0",
  "#311B92",
  "#00796B",
  "#00695C",
  "#004D40",
  "#F57C00",
  "#EF6C00",
  "#E65100",
  "#C2185B",
  "#AD1457",
  "#880E4F",
  "#E91E63",
  "#C2185B",
  "#9C27B0",
  "#7B1FA2",
  "#6A1B9A",
  "#4A148C",
  "#AFB42B",
  "#9E9D24",
  "#689F38",
  "#558B2F",
  "#33691E",
];

export function getUserColor(userId: string, userName: string): string {
  const combined = `${userId}:${userName}`;
  const hash = hashStringToInt(combined);

  const index = hash % COLOR_PALETTE.length;
  return COLOR_PALETTE[index];
}
